import { render } from "./FeedPage.vue?vue&type=template&id=fb8670f2&scoped=true"
import script from "./FeedPage.vue?vue&type=script&lang=js"
export * from "./FeedPage.vue?vue&type=script&lang=js"

import "./FeedPage.vue?vue&type=style&index=0&id=fb8670f2&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb8670f2"]])

export default __exports__